export default {"src":"/_next/static/media/hd_icon.8c65cbfc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};